export default {
  title: 'Loppuunmyydyt tuotteet',
  sections: {
    settings: 'Asetukset',
  },
  fields: {
    has_sold_out_items_auto_reset: {
      options: {
        auto_reset: 'Loppuunmyydyt tuotteet merkitään automaattisesti takaisin saataville päivän päätteeksi.',
        manual_reset:
          'Henkilökunnan on merkittävä tuotteet takaisin saataville sen jälkeen, kun ne on merkitty loppuunmyydyiksi.',
      },
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettiin',
  },
};
